import { ContentBlock, EditorState, Modifier, SelectionState } from 'draft-js';
import { PublicUserProfile } from 'api';
import { getFullName } from 'helpers';
import { ALL_MENTIONS_REGEX, SPLIT_MENTION_REGEX } from 'constants/index';

export interface IConvertFromText {
  editorState: EditorState;
  mentions: PublicUserProfile[];
}

interface IMentionsReducer {
  editorState: EditorState;
  mentions: PublicUserProfile[];
}

interface IConvertMention extends IMentionsReducer {
  match: string;
  block: ContentBlock;
}

function mentionsReducer({ editorState, mentions }: IMentionsReducer): EditorState {
  const contentState = editorState.getCurrentContent();
  const blocks = contentState.getBlocksAsArray();

  for (const block of blocks) {
    const text = block.getText();
    const mentionMatches = text.match(ALL_MENTIONS_REGEX) || [];
    const match = mentionMatches[0];

    if (match) {
      editorState = convertMention({ editorState, mentions, match, block });
      return mentionsReducer({ editorState, mentions });
    }
  }

  return editorState;
}

function convertMention({ editorState, mentions, match, block }: IConvertMention): EditorState {
  const selectionState = editorState.getSelection();
  const contentState = editorState.getCurrentContent();

  const blockText = block.getText();
  const blockKey = block.getKey();
  const split = SPLIT_MENTION_REGEX.exec(match);

  const [tag, userId] = split;
  const start = blockText.indexOf(tag);
  const end = start + match.length;
  const user = mentions.find(mentionedUser => mentionedUser.id === userId);

  const nextSelectionState = selectionState.merge({
    anchorOffset: start,
    focusOffset: end,
    anchorKey: blockKey,
    focusKey: blockKey,
  }) as SelectionState;

  const contentStateWithEntity = contentState.createEntity('mention', 'SEGMENTED', {
    mention: user,
  });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const contentStateWithMention = Modifier.replaceText(
    contentState,
    nextSelectionState,
    getFullName(user),
    null,
    entityKey,
  );

  return EditorState.push(editorState, contentStateWithMention, 'apply-entity');
}

const convertFromText = ({ editorState, mentions }: IConvertFromText): EditorState => {
  return mentionsReducer({ editorState, mentions });
};

export default convertFromText;
